import {AppLoader} from './AppLoader';

export const LoadingView = ():React.ReactNode => {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <AppLoader />
    </div>
  )
};
